/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 * I&C Monitors and Advisors (ICMA)
 */
import React from 'react';
import axios from 'axios';
import AlertComponent from './AlertComponent';

export default class ContentComponent extends React.Component {
  constructor(props) {
    super(props);

    // bind all handlers
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

    // set state
    this.state = {
      selection: props.selection,
      settings: props.settings,
      service: null,
      values: null,
      inProgress: false,
      alerts: []
    };
  }

  async componentWillReceiveProps(newProps) {
    this.clearAlerts();
    if (this.state.selection !== newProps.selection) {
      this.setState({ inProgress: true });
      this.setState({ service: null });
      this.setState({ selection: newProps.selection });
    }

    // get all fields for given selection
    if (newProps.selection) {
      this.getServiceConfiguration(
        newProps.selection.serviceId,
        newProps.selection.usecaseId,
        this.props.ppid
      )
        .then((response) => {
          // create value object
          let values = {};
          response.data.usecases.forEach((usecase) => {
            usecase.calculations.forEach((calculation) => {
              calculation.fields.forEach((field) => {
                values[field.id] = field.currentValue;
              });
            });
          });

          this.setState({ values: values }, () => {
            this.setState({ inProgress: false });
            this.setState({ service: response.data });
          });
        })
        .catch((error) => {
          console.log(error, error.stack);
        });
    }
  }

  /**
   * Request service configuration based on usecase level
   * @param serviceId
   * @param usecaseId
   * @param token
   * @param settings
   */
  getServiceConfiguration(serviceId, usecaseId,ppid) {
    let { token, server } = this.state.settings;
    const url = `${server}${this.props.piCustomDomainPath}/${this.props.configResource}.config/pi.serviceconfigurations/${ppid}/${this.props.deployment}/${serviceId}/${usecaseId}`;
    // call api
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  /**
   * Send current service configuration for ppid
   * @returns {Promise<any>}
   */
  async postServiceConfiguration(serviceId, usecaseId, configuration,ppid) {
    if (this.state.settings.mockApis) {
      await this.createPostServiceConfigurationMock(
        serviceId,
        usecaseId,
        configuration
      );
    }
    let { token, server } = this.state.settings;

    const url = `${server}${this.props.piCustomDomainPath}/${this.props.configResource}.config/pi.serviceconfigurations/${ppid}/${this.props.deployment}/${serviceId}/${usecaseId}`;

    // call api
    return axios({
      method: 'post',
      url: url,
      headers: { Authorization: `Bearer ${token}` },
      data: configuration
    });
  }

  /**
   * Handler for submitting and sending the current configuration to backend
   * @param e
   */
  handleSubmit(e) {
    e.preventDefault();

    this.clearAlerts();

    // TODO: show loader

    // TODO: check if the usecase contains any fields

    // TODO: check if there are any changes

    //console.log(`send configuration for serviceId '${this.props.selection.serviceId}' and usecaseId '${this.props.selection.usecaseId}' to backend: `, this.state.values);

    // send current settings to backend
    this.postServiceConfiguration(
      this.props.selection.serviceId,
      this.props.selection.usecaseId,
      this.state.values,
      this.props.ppid
    )
      .then(({ data }) => {
        // TODO: remove loader
        if (data === 200) {
          this.createAlert(
            'success',
            `Service configuration successfully set.`
          );
        } else {
          this.createAlert('error', data.errorMessage);
        }
      })
      .catch((error) => {
        // TODO: remove loader
        console.log(error, error.stack);
        this.createAlert('error', 'Configuration could not be set.');
      });
  }

  /**
   * Handler for all changes of the input fields
   * @param e
   */
  handleChange(e) {
    e.preventDefault();
    let id = e.target.id;
    let value = e.target.value;
    let values = {};
    values[id] = value;

    let newValues = Object.assign({}, this.state.values, values);
    this.setState({ values: newValues });
  }

  render() {
    const selection = this.state.selection;
    const service = this.state.service;

    if (service) {
      // create list of fields
      let fieldElements = [];
      this.state.service.usecases.forEach((usecase) => {
        usecase.calculations.forEach((calculation) => {
          fieldElements.push(
            <h2
              className="application-header-ah3 dls-cs-custom-header ng-binding"
              key={calculation.calculation}
              style={{
                lineHeight: '24px',
                borderBottom: 'solid 1px #303040',
                marginBottom: '5px',
                marginTop: '20px'
              }}
            >
              {calculation.name}
            </h2>
          );
          calculation.fields.forEach((field) => {
            fieldElements.push(this.createFieldElement(field));
          });
        });
      });

      let alerts = this.state.alerts.map((alert, index) => (
        <AlertComponent
          index={index}
          key={index}
          type={alert.type}
          message={alert.message}
          doRemoveAlert={(alertIndex) => this.doRemoveAlert(alertIndex)}
        />
      ));

      if (this.filterEmptyValues(fieldElements).length > 1) {
        return (
          <div>
            {this.props.menuDesc && (
              <div id="dls-cs-description" className="dls-cs-decription-top">
                {this.props.menuDesc}
              </div>
            )}
            <div className="dls-cs-content">
              {alerts}
              <div>{fieldElements}</div>
              <div className="dls-cs-button-group">
                <button className="dls-cs-button" onClick={this.handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="dls-cs-content">
            <div>
              <h2>
                No settings available for use case "{selection.usecaseId}"
              </h2>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div className="dls-cs-content">
          <div className="dls-cs-error">
            <h2>{this.state.inProgress ? 'Loading...' : ''}</h2>
          </div>
        </div>
      );
    }
  }

  /**
   * Creates different types of fields based on the property "fieldType"
   * @param field
   * @returns {*}
   */
  createFieldElement(field) {
    let fieldType = field.fieldType;
    let element;
    switch (fieldType) {
      case 'select':
        element = this.createSelectField(field);
        break;
      case 'text':
      case 'number':
        element = this.createInputField(field);
        break;
      default:
        console.log(
          `undefined type: ${field.fieldType}, field will be not created`,
          field
        );
    }
    return element;
  }

  /**
   * Creates a input field
   * @param field
   * @returns {*[]}
   */
  createInputField(field) {
    return (
      <div
        style={{ margin: '10px', display: 'table' }}
        key={`${field.fieldName}-${field.id}`}
      >
        <label
          style={{ width: '300px', float: 'left', clear: 'right' }}
          className="ng-binding"
        >
          {field.fieldName}
        </label>
        <input
          value={this.state.values[field.id] || ''}
          onChange={this.handleChange}
          id={field.id}
          key={field.id}
          type={field.fieldType}
          className="dls-cs-custom-text"
        />
      </div>
    );
  }

  /**
   * Creates a select field
   * @param field
   * @returns {*[]}
   */
  createSelectField(field) {
    let options = field.valueInstances.map(function (valueInstance) {
      return (
        <option
          value={valueInstance}
          key={`${field.id}-${valueInstance}`}
        >
          {valueInstance}
        </option>
      );
    });

    return (
      <div
        style={{ margin: '10px', display: 'table' }}
        key={`${field.fieldName}-${field.id}`}
      >
        <label
          style={{ width: '300px', float: 'left', clear: 'right' }}
          className="ng-binding"
        >
          {field.fieldName}
        </label>
        <select
          value={this.state.values[field.id] || 0}
          onChange={this.handleChange}
          id={field.id}
          key={field.id}
          className='dls-cs-custom-select dls-cp-select-alignment'
        >
          <option value="0">
            Please select
          </option>
          {options}
        </select>
      </div>
    );
  }

  /**
   * Remove empty values from given array
   * @param arr
   * @returns {*}
   */
  filterEmptyValues(arr) {
    return arr.filter((x) => x);
  }

  /**
   * Creates an alert at the top of the page for different types (error, warning, success) and sets the background based on the type (see css classes)
   * @param type
   * @param message
   */
  createAlert(type, message) {
    // check type of message and set fallback to error
    type =
      type === 'error' || type === 'warning' || type === 'success'
        ? type
        : 'error';
    this.setState({
      alerts: [...this.state.alerts, { type: type, message: message }]
    });
  }

  /**
   * Removes all errors from page
   */
  clearAlerts() {
    this.setState({
      alerts: []
    });
  }

  /**
   * Remove alert from array based on the passed index from the AlertComponent
   * @param alertIndex
   */
  doRemoveAlert(alertIndex) {
    let newAlerts = this.state.alerts;
    newAlerts.splice(alertIndex, 1);
    this.setState({
      alerts: newAlerts
    });
  }
}
